import React from 'react';
import { TableContainer, Box, Paper, Table, TableCell, TableHead, TableRow, TableBody, Button, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import useStyles from '../../../themes/makeStyles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 10,
    },
}))(TableCell);

export default function InventoryStatus(props) {
    const warehouseData = window.top !== window.self ?
        JSON.parse('{"warehouse_code":"WHJH003","warehouse_name":"IM Section- Jamshedpur"}') :
        JSON.parse(sessionStorage.getItem("warehouseData")) || {};

    const classes = useStyles();
    const handleCurrentInventory = (data) => {
        props.getAddBtnData(data)
    }
    const handleExpectedInventory = (data) => {
        props.getAddBtnData(data)
    }


    return (
        <TableContainer component={Paper} className={classes.container}>
            <Table className={classes.table} aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        {[0, 1, 2, 3, 4, 5, 6].map((each, index) => <StyledTableCell> {index == 3 ? <b>Inventory Status Table</b> : ''} </StyledTableCell>)}
                    </TableRow>
                </TableHead>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>
                            <b>Inventory Status</b>
                        </StyledTableCell>
                        <StyledTableCell>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>No. of items</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Value (Cr.)</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b> {warehouseData.warehouse_name.includes('Pravesh') ? "Qty (NOs)" : "Qty (MT)"} </b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Space Occupied (Sq Ft.)</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Balance Space (Sq Ft.)</b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row">
                            <b>Current Inventory</b>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <Tooltip title={!props.currentInventoryTable ? "Click to display - Current Invetory detail table" : "Close"}>
                                <Button onClick={() => handleCurrentInventory("currentInventory")} color='primary' variant='outlined'> <h3>{!props.currentInventoryTable ? <b> +</b> : <b>-</b>}</h3> </Button>
                            </Tooltip>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <b> {(props.currentInventoryInbound[0] && props.currentInventoryInbound[0].no_of_items) ? props.currentInventoryInbound[0].no_of_items : 0} </b>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[0] && props.currentInventoryInbound[0].value_in_cr) ? props.currentInventoryInbound[0].value_in_cr : 0}</b>
                        </TableCell>
                        {warehouseData.warehouse_name.includes('Pravesh') ? <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[0] && props.currentInventoryInbound[0].unloading_quantity) ? props.currentInventoryInbound[0].unloading_quantity : 0}</b>
                        </TableCell> :
                            <TableCell component="th" scope="row">
                                <b>{(props.currentInventoryInbound[0] && props.currentInventoryInbound[0].gross_weight) ? props.currentInventoryInbound[0].gross_weight : 0}</b>
                            </TableCell>}
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[0] && props.currentInventoryInbound[0].bin_space_allocated) ? props.currentInventoryInbound[0].bin_space_allocated : 0}</b>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[0] && props.currentInventoryInbound[0].remaining_bin_size) ? props.currentInventoryInbound[0].remaining_bin_size : 0}</b>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell component="th" scope="row">
                            <b>Expected Inventory</b>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <Tooltip title={!props.expectedInventoryTable ? "Click to display Expected Invetory detail table" : "Close"}>
                                <Button onClick={() => handleExpectedInventory("expectedInventory")} color='primary' variant='outlined'> <h3>{!props.expectedInventoryTable ? <b> +</b> : <b>-</b>}</h3> </Button>
                            </Tooltip>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[1] && props.currentInventoryInbound[1].no_of_items) ? props.currentInventoryInbound[1].no_of_items : 0}</b>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[1] && props.currentInventoryInbound[1].value_in_cr) ? props.currentInventoryInbound[1].value_in_cr : 0}</b>
                        </TableCell>
                        {warehouseData.warehouse_name.includes('Pravesh') ? <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[1] && props.currentInventoryInbound[1].unloading_quantity) ? props.currentInventoryInbound[1].unloading_quantity : 0}</b>
                        </TableCell> :
                            <TableCell component="th" scope="row">
                                <b>{(props.currentInventoryInbound[1] && props.currentInventoryInbound[1].gross_weight) ? props.currentInventoryInbound[1].gross_weight : 0}</b>
                            </TableCell>}
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[1] && props.currentInventoryInbound[1].bin_space_allocated) ? props.currentInventoryInbound[1].bin_space_allocated : 0}</b>
                        </TableCell>
                        <TableCell component="th" scope="row">
                            <b>{(props.currentInventoryInbound[1] && props.currentInventoryInbound[1].remaining_bin_size) ? props.currentInventoryInbound[1].remaining_bin_size : 0}</b>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
} 